import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		navy: {
			900: '#070b14',
			800: '#0b1329',
			700: '#111c38',
			600: '#1a274c',
			500: '#263765'
		},
		brand: {
			50: '#e6fffa',
			100: '#b2f5ea',
			200: '#81e6d9',
			300: '#4fd1c5',
			400: '#319795',
			500: '#0d9488',
			600: '#0f766e',
			700: '#115e59',
			800: '#134e4a',
			900: '#042f2e'
		},
		cyan: {
			400: '#22d3ee',
			500: '#06b6d4',
			600: '#0891b2'
		},
		slate: {
			50: '#f8fafc',
			100: '#f1f5f9',
			200: '#e2e8f0',
			300: '#cbd5e1',
			400: '#94a3b8',
			500: '#64748b',
			600: '#475569',
			700: '#334155',
			800: '#1e293b',
			900: '#0f172a'
		}
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode('slate.50', 'navy.800')(props),
				color: mode('slate.800', 'slate.100')(props),
				fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
				lineHeight: '1.6'
			},
			html: {
				fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
			},
			'::-webkit-scrollbar': {
				width: '8px',
				height: '8px'
			},
			'::-webkit-scrollbar-track': {
				background: mode('slate.100', 'navy.900')(props)
			},
			'::-webkit-scrollbar-thumb': {
				background: mode('slate.300', 'navy.600')(props),
				borderRadius: '4px'
			},
			'::-webkit-scrollbar-thumb:hover': {
				background: mode('slate.400', 'cyan.600')(props)
			}
		})
	}
};

